import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PieceList from "../../components/piece/pieceList";
import SearchBar from "../../components/searchBar";
import { getApiUrl } from "../../data/api/apiManager";

import { Helmet } from "react-helmet";
import ConfirmedIcon from "../../assets/icons/confirmedIcon";
import Loader from "../../components/loader";
import { useAppContext } from "../../context/appContext";
import { ArtistResponseDTO, ArtistResponseDTOFull, ContributionResponseDTO } from "../../openapi-generated-client";
import "./singleArtist.css";
import SocialMediaLink from "./socialMediaNetwork";

export default function SingleArtistPage() {
    
    const {artistController} = useAppContext();

    const {id} = useParams();

    const [data, setData] = useState<ArtistResponseDTOFull>();

    async function fetchData() {
        const idNumber = Number(id);
        if(isNaN(idNumber)) {
            window.location.href = "/error/2";
            return;
        }
        await artistController.getArtist(Number(id)).catch((e) => {
            if(e.status == 404) {
                window.location.href = "/error/3";
            }
        }).then((response) => {
            if(response) {
                setData(response.data);
            }
        });
    }

    useEffect(() => {
        fetchData();
    }, []);


    const [pieceSearch, setPieceSearch] = useState("");

    if(data == undefined) return <Loader/>;

    var allPieces: ContributionResponseDTO[] = [];
    for(let i = 0; i < data.pieces.length; i++) {
        allPieces.push({
            contributionType: "",
            piece: data.pieces[i]
        });
    }
    for(let i = 0; i < data.contributions.length; i++) {
        allPieces.push(data.contributions[i]);
    }


    return <>
        <article className="single-artist-header" itemScope itemType="https://schema.org/Person">
            <Helmet>
                <title>{data.name} | Txoria</title>
            </Helmet>
            <div className="info">
                <img itemProp="image" className="composer-image" src={getApiUrl("assets/by-hash/" + data.artistProfile.profilePicture)} alt={data.name + " Profile Picture"} />
                <h1 itemProp="name">{data.name}{data.verified ? <ConfirmedIcon/> : <></>}</h1>
                <a itemProp="description">{data.artistProfile.shortBiography}</a>
            </div>
            {Object.keys(data.artistProfile.socialMedia).length > 0 || data.artistProfile.biography != "" ? <>
            <hr/>
            <div className="description-section">
                {data.artistProfile.biography != "" ? <div className="description">
                    <h3>Description</h3>
                    <p>{data.artistProfile.biography}</p>
                </div> : <></>}
                {Object.keys(data.artistProfile.socialMedia).length > 0 ? <div className="social-media">
                        {Object.keys(data.artistProfile?.socialMedia).map((network) => {
                            if(data.artistProfile?.socialMedia[network] == undefined || data.artistProfile?.socialMedia[network] == "") return <></>;
                            return <SocialMediaLink network={network} link={data.artistProfile?.socialMedia[network]}/>;
                        })}
                    </div> : <></>}
            </div>
            </> : <></>}
        </article>
        <div className="page single-artist keep-margin">
            <h3>Pieces</h3>
            <SearchBar search={pieceSearch} onSearch={setPieceSearch}/>
            <PieceList displayProps={{
                linkPrefix: "/pieces"
            }} pieces={
                allPieces.filter(c => c.piece.title.toLowerCase().includes(pieceSearch.toLowerCase()) || c.piece.author.toLowerCase().includes(pieceSearch.toLowerCase()) || c.piece.realComposer.toLowerCase().includes(pieceSearch.toLowerCase())).map(c => {
                    return {
                        piece: c.piece,
                        wrapper: <div className="contribution-wrapper">
                            {c.contributionType != "" ? <span className="contribution-type">{c.contributionType}</span> : <></>}
                        </div>
                    }
                })
            }/>
            {/* <PieceList displayProps={{
                linkPrefix: "/pieces"
            }} searchQuery={pieceSearch} pieces={allPieces}/> */}
        </div>
    </>;
}